/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Label } from 'src/modules/labeling/types/Label';

/**
 * Returns 2d array of labels, grouped by the same start and end index.
 */
export const groupLabelsByBoundaries = (labels: Label[]): Label[][] => {
    const map = new Map<string, Label[]>();

    labels.forEach(label => {
        const key = `${label.start}:${label.end}`;
        let labelsArr: Label[];
        if (map.has(key)) {
            labelsArr = map.get(key);
        } else {
            labelsArr = [];
            map.set(key, labelsArr);
        }

        labelsArr.push(label);
    });

    return [...map.values()];
};
